import React from 'react';
import { TooltipProps } from 'antd';
import { StyledTooltip, TooltipIcon } from './styled';

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  visible,
  ...rest
}) => (
  <>
    <StyledTooltip
      {...rest}
      getPopupContainer={(triggerNode) => triggerNode as HTMLElement}>
      <TooltipIcon active={visible}>{children}</TooltipIcon>
    </StyledTooltip>
  </>
);
